import React, {Component} from 'react';
import styles from './Campaign.css';
import Observer from 'react-intersection-observer'
import ScrollPercentage from 'react-scroll-percentage'
import Framer from "../Framer/Framer"
import {CampaignDisplayType, FrameStates} from "../../constants/consts-types"
import {TypeComponentCampaign} from "../../constants/consts-prop-types"
import {getViewPortHeight, isHD, isDesktop} from "../../services/service-utils"
import CampaignHeadersView from "./CampaignHeadersView"
import {loadImage} from "../../services/service-image-loader"

class CampaignFrame extends Component {
  static propTypes = {
    data: TypeComponentCampaign,
  }

  constructor(props) {
    super(props)

    this.state = {
      frame: FrameStates.CAMPAIGN,
      imageSrc: null,
      isDesktop: isDesktop(),
      isHD: isHD(),
      nodeHeight: getViewPortHeight(),
    }

    this.onResize = this.onResize.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize)

    this.setState({
      nodeHeight: getViewPortHeight(),
    })

    loadImage(this.props.data.image_url, this)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  componentDidUpdate(prevProps) {
    if(this.props.data.image_url !== prevProps.data.image_url) {
      loadImage(this.props.data.image_url, this)
    }
  }

  onResize() {
    this.setState({
      isDesktop: isDesktop(),
      isHD: isHD(),
      nodeHeight: getViewPortHeight(),
    })
  }

  render() {
    const {data} = this.props

    const {
      display,
      colors,
    } = data

    const {
      imageSrc,
      isDesktop,
      frame,
      nodeHeight
    } = this.state

    const with_border = Boolean(display === CampaignDisplayType.FULLSCREEN_FRAME)

    const stylesCampaign = {
      height: isDesktop ? `${nodeHeight}px` : 'auto',
      color: colors && colors.foreground ? colors.foreground : '',
      backgroundColor: colors && colors.background ? colors.background : ''
    }

    const colClasses = with_border ? 'col-xs-10 col-xs-offset-1 col-md-offset-5 col-md-6 col-lg-4' : 'col-xs-10 col-md-6 col-lg-4'

    return (
      <section
        className={with_border ? styles.CampaignFrame : styles.Campaign}
        style={stylesCampaign}
      >

        {with_border &&
        <Framer
          state={frame}
          colors={colors}
        />
        }

        <ScrollPercentage className={styles.scrollPercentageFrame}>
          {({percentage}) => {
            const offsetY = (-.5 + percentage) * 20
            return (
              <div
                className={imageSrc ? styles.backgroundImageFullScreenLoaded : styles.backgroundImageFullScreen}
                style={{
                  backgroundImage: imageSrc ? `url(${imageSrc})` : 'none',
                  transform: `translateY(${offsetY}%)`
                }}
              />
            )
          }}
        </ScrollPercentage>

        <div className="container-fluid">
          <div className="row" style={{height: '100%'}}>
            <div className={colClasses}>

              <Observer style={{height: with_border ? '100%' : '80%'}}>
                {({inView, ref}) => (
                  <article className={styles.contentFramed} ref={ref}>
                    <CampaignHeadersView inView={inView} fullscreenImage={true} data={data}/>
                  </article>
                )}
              </Observer>

            </div>
          </div>
        </div>

      </section>
    );
  }
}

export default CampaignFrame;



// WEBPACK FOOTER //
// ./src/components/Campaign/CampaignFrame.js